import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['observedCheckbox', 'disableableCheckbox', 'disableableLabel']

  evaluateCheckboxesState() {
    const shouldDisable = !this.areObservedCheckboxesChecked()
    this.disableableCheckboxTargets.forEach(checkbox => { checkbox.disabled = shouldDisable })
    this.disableableLabelTargets.forEach(label => {
      if (shouldDisable) {
        label.classList.add('text-gray-power')
        label.classList.remove('text-taupe-dark')
      } else {
        label.classList.remove('text-gray-power')
        label.classList.add('text-taupe-dark')
      }
    })
  }

  areObservedCheckboxesChecked() {
    return this.observedCheckboxTargets.some(checkbox => checkbox.disabled === false && checkbox.checked === true)
  }
}
